import React, { useEffect } from 'react'
import Modal from '../../../../components/Modal'
import * as S from './ModalCreateDock.styles'
import { useForm } from 'react-hook-form'
import { handleOnKeyDown } from 'src/utils/Form'
import { useSelector } from 'src/utils/store'
import { selectFulfillmentCenters } from 'src/features/selector'
import { useDispatch } from 'react-redux'
import { actions } from 'src/features/dock-management/DockManagementState'
import { CreateNewDockParams } from '../../DockManagementTypes'
import { SelectMui } from 'src/components/SelectMui'
import TextFieldMui from 'src/components/TextFieldMui'
import { ButtonMui } from 'src/components/ButtonMui'

interface ModalCreateDockProps {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  isOpen: boolean
}

const ModalCreateDock = ({ setIsOpen, isOpen }: ModalCreateDockProps) => {
  const dispatch = useDispatch()
  const fcs = useSelector(selectFulfillmentCenters)
  const isLoading = useSelector((state) => state.app.isLoading)

  const {
    handleSubmit, reset, register, formState: { errors },
  } = useForm<CreateNewDockParams>()

  const prepareFcs = () =>
    fcs.map((fulfillmentCenter) => ({
      id: fulfillmentCenter.id,
      description: fulfillmentCenter.name,
    }))

  const optionsNoYes = [
    { id: 0, description: 'Não' },
    { id: 1, description: 'Sim' },
  ]

  useEffect(() => {
    reset()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  const cancelModal = () => {
    setIsOpen(!isOpen)
  }

  const onSubmit = async (data: CreateNewDockParams) => {
    const dataFormatted = { ...data, fresh: Boolean(data.fresh), express: Boolean(data.express) }
    dispatch(actions.createNewDock(dataFormatted))
  }

  return (
    <Modal
      testId='modal-create-dock'
      show={isOpen}
      closedButton={false}
      title='CADASTRO DE NOVAS DOCAS'
      titleStyle={{ fontSize: '16px', letterSpacing: '1.5px' }}
      size='lg'
      IconLeft={() => <S.HouseIcon />}
      body={(
        <S.BodyModal>
          <S.Form onSubmit={handleSubmit((data) => onSubmit({ ...data, onSuccess: cancelModal }))}>
            <S.InputContainer>
              <S.GridContainer columns={2}>
                <SelectMui
                  inputProps={{ ...register('fulfillmentCenterId', { required: 'Campo obrigatório' }) }}
                  id='fulfillmentCenterId'
                  error={!!errors.fulfillmentCenterId}
                  label='Selecione um FC'
                  helperText={errors.fulfillmentCenterId?.message}
                  variant='outlined'
                  options={prepareFcs()}
                  size='small'
                  type='number'
                  onKeyDown={(e) => handleOnKeyDown(e, 'defaultLocation')}
                  fullWidth
                  optionNone={false}
                  autoFocus
                />
                <TextFieldMui
                  margin='none'
                  id='dockCode'
                  name='dockCode'
                  autoComplete='off'
                  size='small'
                  inputProps={{ ...register('dockCode', { required: 'Campo obrigatório' }), 'data-testid': 'input-dock-code' }}
                  error={!!errors.dockCode}
                  label='dockManagement.code'
                  helperText={errors.dockCode?.message}
                  onKeyDown={(e) => handleOnKeyDown(e, 'isFresh')}
                />
                <SelectMui
                  inputProps={{ ...register('fresh', { required: 'Campo obrigatório' }) }}
                  id='isFresh'
                  error={!!errors.fresh}
                  helperText={errors.fresh?.message}
                  label='Fresh'
                  variant='outlined'
                  options={optionsNoYes}
                  size='small'
                  onKeyDown={(e) => handleOnKeyDown(e, 'isExpress')}
                  fullWidth
                  optionNone={false}
                />
                <SelectMui
                  inputProps={{ ...register('express', { required: 'Campo obrigatório' }) }}
                  id='isExpress'
                  error={!!errors.express}
                  helperText={errors.express?.message}
                  label='Expressa'
                  variant='outlined'
                  options={optionsNoYes}
                  size='small'
                  onKeyDown={(e) => handleOnKeyDown(e, 'confirmButton')}
                  fullWidth
                  optionNone={false}
                />

                <TextFieldMui
                  id='groceryLocation'
                  name='groceryLocation'
                  autoComplete='off'
                  disableSubmit={false}
                  margin='none'
                  size='small'
                  inputProps={{ ...register('groceryLocation', { required: 'Campo obrigatório' }), 'data-testid': 'input-location-grocery' }}
                  error={!!errors.groceryLocation}
                  label='dockManagement.destinationGrocery'
                  helperText={errors.groceryLocation?.message}
                  onKeyDown={(e) => handleOnKeyDown(e, 'dockCode')}
                />
                <TextFieldMui
                  id='freshLocation'
                  name='freshLocation'
                  autoComplete='off'
                  disableSubmit={false}
                  margin='none'
                  size='small'
                  inputProps={{ ...register('freshLocation', { required: 'Campo obrigatório' }), 'data-testid': 'input-location-fresh' }}
                  error={!!errors.freshLocation}
                  label='dockManagement.destinationFresh'
                  helperText={errors.freshLocation?.message}
                  onKeyDown={(e) => handleOnKeyDown(e, 'dockCode')}
                />
              </S.GridContainer>
            </S.InputContainer>
            <S.ContainerButton>
              <ButtonMui
                title='Confirmar'
                id='confirmButton'
                type='submit'
                testId='button-confirm'
                bgColor='blue'
                hoverColor='darkBlueHover'
                letterColor='white'
                disabled={isLoading}
              />
              <ButtonMui
                title='Cancelar'
                onClick={cancelModal}
                testId='cancel-button'
                bgColor='red'
                hoverColor='redHover'
                letterColor='white'
              />
            </S.ContainerButton>
          </S.Form>
        </S.BodyModal>
      )}
    />
  )
}

export default ModalCreateDock
